import React from "react";
import PropTypes from "prop-types";
import {
  DropdownButton,
  MenuItem,
  ButtonToolbar,
  Button,
} from "react-bootstrap";
import Slider from "react-slick";
import ReactPixel from "react-facebook-pixel";
import RestrictedStateWiseComponent from "./RestrictedStateWiseComponent";
import Link from "gatsby-link";
import { connect } from "react-redux";
import "../css/productCard.css";

const PackType = {
  0: "Mini Pouch",
  1: "Carton",
  2: "Pouch",
  3: "Incense sticks",
  4: "Pack",
};

let settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};
const WeightAndPriceDropdown = ({ title, items, handleWtList, activeKey }) => {
  return (
    <DropdownButton id={title} bsStyle="default" title={`${title}`}>
      {items.map((item, i) => {
        return (
          <MenuItem
            onClick={() => handleWtList(item)}
            active={activeKey === item.id}
            key={i}
            eventKey={i}
          >
            {item.netWeight} {PackType[item.packType]} at Rs. {item.mrp}
          </MenuItem>
        );
      })}
    </DropdownButton>
  );
};

WeightAndPriceDropdown.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  handleWtList: PropTypes.func,
  activeKey: PropTypes.number,
  cartChange: PropTypes.bool,
};
export class ProductStoreCard extends React.Component {
  constructor(args) {
    super(args);
    const { product } = this.props;
    this.state = {
      qty: product.qty || 1,
      added: product.qty > 0,
      lastCounter: 30,
      activeWtList: {},
      activeKey: product.id,
      isFetching: true,
    };
  }
  componentDidMount() {
    const { location, product, addToCartList } = this.props;
    this.setTheInitialValues(product, addToCartList);
    ReactPixel.init("145006083100066");
    ReactPixel.track("ViewContent", location);
  }
  componentWillReceiveProps(nextProps) {
    // this.setState({
    // 	isLoading: true
    // })
    // console.log("nextProps", nextProps)
    if (nextProps.product.qty !== this.props.product.qty) {
      const { product } = nextProps;
      // console.log("nextProps", nextProps)
      this.setTheInitialValues(product, nextProps.addToCartList);
    }
  }
  setTheInitialValues = (product, addToCartList) => {
    const { uniqueProductItems } = this.props;
    this.weightList = [];
    const { activeKey } = this.state;
    // addToCartList = addToCartList.products
    // console.log("activeKey", addToCartList)
    // let index
    uniqueProductItems.map((item, i) => {
      // if (item.u_id === activeKey) {
      // 	index = i
      // }

      this.weightList.push({
        ...item,
        qty: addToCartList[item.id] ? addToCartList[item.id].qty || 1 : 1,
        added: addToCartList[item.id] ? addToCartList[item.id].qty > 0 : false,
      });
    });
    this.setState({
      activeWtList: {
        ...product,
        qty: addToCartList[product.id] ? addToCartList[product.id].qty : 1,
        added: addToCartList[product.id]
          ? addToCartList[product.id].qty > 0
          : false,
      },
      activeKey: this.state.activeKey || product.id,
      change: !this.state.change,
      isFetching: false,
    });
  };
  handleQuantity = (fn) => {
    let { activeKey, activeWtList } = this.state;
    let activeIndex;
    this.weightList.map((item, i) => {
      if (activeKey === item.id) {
        activeIndex = i;
      }
    });
    if (fn === "add") {
      activeWtList.qty = activeWtList.qty + 1;
      // activeWtList.added = true
    } else {
      if (activeWtList.qty - 1 >= 0) {
        activeWtList.qty = activeWtList.qty - 1;
      }
      if (activeWtList.qty === 0) {
        activeWtList.added = false;
      }
    }
    activeWtList.added = false;
    this.weightList[activeIndex] = activeWtList;
    this.setState({
      activeWtList: activeWtList,
    });
  };
  addToCart = () => {
    const { product, setToCart } = this.props;
    const { qty, activeKey, activeWtList } = this.state;
    // window.localStorage.setItem("cart", {})
    let cart = JSON.parse(localStorage.getItem("cart"));
    let activeIndex;
    this.weightList.map((item, i) => {
      if (item.id === activeKey) {
        activeIndex = i;
        this.weightList[i].added = true;
      }
    });
    let addedProduct = {
      ...activeWtList,
    };
    if (!cart) {
      cart = {
        products: {},
        totalNumber: 0,
      };
    }
    let totalNumber = 1;
    let bucket = {
      products: {
        ...cart.products,
        [addedProduct.id]: addedProduct,
      },
      totalNumber: totalNumber,
    };
    localStorage.setItem("cart", JSON.stringify(bucket));
    setToCart(bucket);
  };
  handleWtList = (item) => {
    // console.log("tiem,", item)
    this.setState({
      activeWtList: item,
      activeKey: item.id,
    });
  };
  render() {
    const { region, listItemById } = this.props;
    const { activeKey, activeWtList, isFetching } = this.state;
    if (isFetching) {
      return null;
    }
    let product = activeWtList;
    let imgUrl = activeWtList.imgUrls.length ? activeWtList.imgUrls[0] : null;
    let wtLabel = `${activeWtList.netWeight} ${
      PackType[activeWtList.packType]
    } at Rs ${activeWtList.mrp}`;
    return (
      <div className="card product__card__wrapper">
        <div className="slider__content">
          <Slider {...settings}>
            {product.imgUrls.map((item, i) => {
              return (
                <div key={i} className="slider__img">
                  <img
                    src={item}
                    alt={product.productName}
                    className="img img-responsive"
                  />
                </div>
              );
            })}
          </Slider>
        </div>
        <div className="media" style={{ margin: "0" }}>
          <a
            style={{ textDecoration: "none", color: "" }}
            href={`/products/Detail?${product.type}&${product.urlName.replace(
              / /g,
              "-"
            )}`}
          >
            <div className="card__title">{product.productName}</div>
          </a>
        </div>
        <div className="row">
          {/* <div className="col-xs-5" style={{ textAlign: "left" }}>
											<div className="card__qty">
												Weight
											</div>
											<div className="card__wt">{product.netWeight}</div>
										</div> */}
          <div className="col-xs-5 weight__list" style={{ textAlign: "left" }}>
            <ButtonToolbar>
              <WeightAndPriceDropdown
                handleWtList={this.handleWtList}
                activeKey={activeKey}
                title={wtLabel}
                items={this.weightList}
              />
            </ButtonToolbar>
          </div>
          <div className="col-xs-5 pull-right" style={{ textAlign: "right" }}>
            <div className="card__qty">Price</div>
            <div className="card__price">
              <i className="fa fa-inr" aria-hidden="true" /> {product.mrp}
            </div>
          </div>
        </div>
        {product.type !== "Dhoop" ? (
          <RestrictedStateWiseComponent regionName={region}>
            <div className="row" style={{ marginTop: "10px" }}>
              <div className="col-xs-4 col-md-6">
                <div className="input-group qty">
                  <span className="input-group-btn">
                    <button
                      onClick={() => this.handleQuantity("sub")}
                      type="button"
                      className="quantity-left-minus btn btn-default btn-number"
                      data-type="minus"
                      data-field=""
                    >
                      <span className="glyphicon glyphicon-minus" />
                    </button>
                  </span>
                  <input
                    readOnly
                    type="text"
                    id="quantity"
                    name="quantity"
                    className="form-control input-number"
                    value={product.qty || 1}
                    min="1"
                    max="100"
                  />
                  <span className="input-group-btn">
                    <button
                      onClick={() => this.handleQuantity("add")}
                      type="button"
                      className="quantity-right-plus btn btn-default btn-number"
                      data-type="plus"
                      data-field=""
                    >
                      <span className="glyphicon glyphicon-plus" />
                    </button>
                  </span>
                </div>
              </div>
              {/*
							<div className="col-xs-4 col-md-6">
							<div className="card__btn">
								{product.qty > 0 && product.added
									? <Button>Added</Button>
									: <Button onClick={() => this.addToCart(product)}>Add To Cart</Button>
								}
							</div>
						</div>
						*/}
            </div>
          </RestrictedStateWiseComponent>
        ) : null}

        <a
          href={`/products/Detail?${product.type}&${product.urlName.replace(
            / /g,
            "-"
          )}`}
          className="view-btn"
        >
          View
        </a>
      </div>
    );
  }
}

ProductStoreCard.propTypes = {
  product: PropTypes.object,
  setToCart: PropTypes.func,
  isCartChange: PropTypes.bool,
  uniqueProductItems: PropTypes.object,
};
const mapStateToPropsView = (state, ownProps) => {
  const { product } = ownProps;
  return {
    ...ownProps,
    product: state.addToCartList.products[product.id] || product,
    region: state.ipData.region || "delhi",
    uniqueProductItems: state.products.uIdListItemById[product.u_id] || [],
    listItemById: state.products.listItemById,
    isCartChange: state.addToCartList.isAddToCartChange,
    addToCartList: state.addToCartList.products,
    // region: "XYX"
  };
};

const mapDispatchToPropsView = (dispatch) => {
  return {
    setToCart: (bucket) =>
      dispatch({ type: `SET_TO_CART`, addToCartList: bucket }),
  };
};

export default connect(
  mapStateToPropsView,
  mapDispatchToPropsView
)(ProductStoreCard);



// WEBPACK FOOTER //
// ./src/components/ProductStoreCard.js